<template>
  <a-spin :spinning="loading">
    <TeamLeader/>
    <a-tabs default-active-key="1" size="large">
      <a-tab-pane key="1" tab="报名费" :forceRender="true">
        <SignUpAmount ref="signUpAmount" @paySuccess="paySuccess"/>
      </a-tab-pane>
      <a-tab-pane key="2" tab="保险费" :forceRender="true">
        <InsuranceAmount ref="insuranceAmount" @paySuccess="paySuccess"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
import InsuranceAmount from '@comm/components/join/pay/InsuranceAmount'
import SignUpAmount from './SignUpAmount'
import TeamLeader from '../staff/TeamLeader'
export default {
  components: {
    TeamLeader,
    InsuranceAmount,
    SignUpAmount
  },
  data () {
    return {
      buyInsuranceBtnName: '选中项缴纳保险',
      loading: false,
      bxChecked: false,
      signUpData: null,
      // matchFun,
      selectedCardIds: [],
      needPhonePlayers: []
    }
  },
  methods: {
    paySuccess (alertMsg) {
      let signUpPayOver = this.$refs.signUpAmount.payOver()
      console.log('signUpPayOver', signUpPayOver)
      if (!signUpPayOver.status) {
        if (alertMsg) {
          this.$message.warning(signUpPayOver.content)
          return
        }
      }
      let insurancePayOver = this.$refs.insuranceAmount.payOver()
      if (!insurancePayOver) {
        if (alertMsg) {
          this.$message.warning('还有队员未购买保险，请先购买保险！')
          return
        }
      }
      if (signUpPayOver && insurancePayOver) {
        this.$emit('payOver')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    font-size: 19px;
    font-weight: bold;
  }
  .coachContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    cursor:pointer;
    .coach {
      width: 60px;
      height: 130px;
      text-align: center;
      margin-left: 20px;
      .head {
        height: 80px;
        width: 60px;
      }
      p {
        cursor:pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .player {
    img {
      height: 50px;
      width: 40px;
    }
    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }
  .btnContent {
    text-align: right;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/StepFour.vue